exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /* color */\n\n  /* font */\n\n  /* link */\n}\n:root {\n  /* цвет */\n\n  /* TODO в фигме другие цвета по названиям scarlet magenta green beeline aquamarine violet, надо решить с дизайнерами  */\n\n  /* токены со ссылкой на глобал цвета */\n\n  /* шрифт */\n\n  /* отступы от шапки и футера до тела страницы */\n\n  /* ширина тела страницы */\n\n  /* отступы между элементами страницы */\n}\n.PopupText_component_3Kps {\n  margin: 40px 0;\n}\n.PopupText_isTitle_1cPQ {\n  margin-bottom: 24px;\n}\n", ""]);

// exports
exports.locals = {
	"component": "PopupText_component_3Kps",
	"isTitle": "PopupText_isTitle_1cPQ"
};